import { ITEM_TYPES } from "@/components/CategoryTree/CategoryTree";
import { SubCategoryFilterItem } from "@/components/filter/SubCategoryFilterItem";
import { multiplyNoun } from "@/helpers/multiplyNoun";
import useSelectedCategory from "@/hooks/useSelectedCategory";

import styles from "./SubCategoryFilter.module.scss";

const SubCategoryFilter = () => {
  const {
    selectedCategoryId,
    selectedRootCategory,
    selectedCollectionId,
    selectedRootCollection,
  } = useSelectedCategory();

  const rootItem = selectedRootCategory || selectedRootCollection;
  if (!rootItem) return;

  const minChildrenAmount = selectedRootCategory ? 1 : 0;

  const selectedId = selectedCategoryId || selectedCollectionId;
  const hasChildren = Number(rootItem.children?.length) > minChildrenAmount;

  const { id, name } = rootItem;
  const itemType = getItemType(selectedCategoryId, selectedCollectionId);

  return (
    <div className={styles.root}>
      <ul className={styles.line}>
        <SubCategoryFilterItem
          id={id}
          name={hasChildren ? multiplyNoun(name) : name}
          selected={id === selectedId}
          itemType={itemType}
        />
        {hasChildren &&
          rootItem.children?.map((category) => (
            <SubCategoryFilterItem
              id={category.id}
              name={category.name}
              selected={category.id === selectedId}
              key={category.id}
              itemType={itemType}
            />
          ))}
      </ul>
    </div>
  );
};

const getItemType = (
  selectedCategoryId?: string,
  selectedCollectionId?: string
) => {
  if (selectedCategoryId) return ITEM_TYPES.CATEGORY;
  if (selectedCollectionId) return ITEM_TYPES.COLLECTION;
  return ITEM_TYPES.CATEGORY;
};

export default SubCategoryFilter;
